import { PERMISSIONS } from '@vy/types';
import { AiSparkles } from '@vy/ui-design-system';
import { ValueOf } from '@vy/utils';
import { NavBarItem } from './side-nav-bar-item';
import { SIDE_NAV_BAR_LABELS } from './side-nav-bar-labels';
import { SIDE_NAV_BAR_ROUTES } from './side-nav-bar-routes';

export const SIDE_NAV_BAR_ITEMS = [
  {
    text: SIDE_NAV_BAR_LABELS.Home,
    icon: 'HomeV2',
    to: SIDE_NAV_BAR_ROUTES.Home,
    permission: undefined,
  },
  {
    text: SIDE_NAV_BAR_LABELS.AiAgents,
    icon: AiSparkles,
    to: SIDE_NAV_BAR_ROUTES.AiAgents,
    permission: undefined,
  },
  {
    text: SIDE_NAV_BAR_LABELS.Customers,
    to: SIDE_NAV_BAR_ROUTES.Customers,
    icon: 'Group',
    permission: [PERMISSIONS.CUSTOMER_READ],
  },
  {
    text: SIDE_NAV_BAR_LABELS.Invoices,
    to: [SIDE_NAV_BAR_ROUTES.Invoices],
    icon: 'InvoiceListItem',
    permission: [PERMISSIONS.INVOICE_READ],
    subItems: [
      {
        text: SIDE_NAV_BAR_LABELS.Overview,
        to: SIDE_NAV_BAR_ROUTES.Overview,
        permission: [PERMISSIONS.INVOICE_READ],
      },
      {
        text: SIDE_NAV_BAR_LABELS.Payments,
        to: SIDE_NAV_BAR_ROUTES.Payments,
        permission: [PERMISSIONS.INVOICE_READ],
      },
    ],
  },
  {
    text: SIDE_NAV_BAR_LABELS.Plans,
    icon: 'Wallet',
    to: SIDE_NAV_BAR_ROUTES.Plans,
    permission: [PERMISSIONS.PLAN_READ],
  },
  {
    text: SIDE_NAV_BAR_LABELS.DataMetering,
    icon: 'ChartStyleBig',
    to: [SIDE_NAV_BAR_ROUTES.Usage, SIDE_NAV_BAR_ROUTES.Events],
    permission: undefined,
    subItems: [
      {
        text: SIDE_NAV_BAR_LABELS.Usage,
        to: SIDE_NAV_BAR_ROUTES.Usage,
        permission: [PERMISSIONS.MEASUREMENT_READ],
      },
      {
        text: SIDE_NAV_BAR_LABELS.Events,
        to: SIDE_NAV_BAR_ROUTES.Events,
        permission: [PERMISSIONS.EVENT_READ],
      },
    ],
  },
  {
    text: SIDE_NAV_BAR_LABELS.Reports,
    icon: 'Reports',
    to: SIDE_NAV_BAR_ROUTES.Reports,
    permission: [PERMISSIONS.REPORT_READ],
    clearSearchOnNavigate: true,
  },
  {
    text: SIDE_NAV_BAR_LABELS.Products,
    icon: 'Products',
    to: SIDE_NAV_BAR_ROUTES.Products,
    permission: [PERMISSIONS.PRODUCT_READ],
  },
  {
    text: SIDE_NAV_BAR_LABELS.Integrations,
    to: SIDE_NAV_BAR_ROUTES.Integrations,
    icon: 'PuzzlePlugInAdd',
    permission: [PERMISSIONS.INTEGRATION_READ],
  },
] satisfies NavBarItem[];

export type SideNavBarItem = ValueOf<typeof SIDE_NAV_BAR_ITEMS>;
